;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router     = APP.module('Router');
	var Model      = APP.module('Model');
	var View       = APP.module('View');
	var Layout     = APP.module('Layout');
	var Collection = APP.module('Collection');

	_.extend(Controller.Tipping.prototype, {

		getTippingData: function() {
			this.tipping_data = new Model.Tipping();
		},

		loginCallback: function() {
			console.log(11111);
			this.start();
			console.log(333, View);
			var controls = new View.TippingLoginCallback();
			console.log(222, controls);

			controls.render();
		},

		gamesList: function() {
			this.start();
			this.getTippingData();


			var controls = new View.TippingControls({
					rounds:   this.rounds,
					round_id: false
				}),
				tips  = new View.TippingTips({
					round_id:   false,
					model:      this.tipping_data,
					rounds:     this.rounds,
					squads:     this.squads,
					venues:     this.venues,
					formGuide:  new Model.TippingFormGuide(),
					collection: new Collection.Tipping(),
					trend:      new Collection.TippingRoundStats(),
				});

			this.tippingLayout.controls.show(controls);
			this.tippingLayout.tips.show(tips);
			this.tippingLayout.gamebar.show(this.getGamebar());
		},

		getWidgets: function() {
			return new Layout.Sidebar({
				widgets_list: ['Promo','AflClubsLadder'],
				widgets_options: {
					rounds:           this.rounds,
					squads:           this.squads,
					collection:       new Collection.TippingRoundStats(),
					ladderCollection: new Collection.TippingLadder()
				}
			});
		},

		leaguesAbout: function (league_id) {
			this.start(league_id);

			var leaguesManage         = new Layout.TippingLeaguesManage(),
				leaguesManageControls = new View.TippingLeaguesManageControls({
					league_id: +league_id,
					model:     new Backbone.Model(),
					share:     this.share,
					leagues:   new Collection.TippingLeagues(),
					ladder:    new Model.Ladder(),
					user:      this.user
				}),
				leaguesAbout          = new View.TippingLeaguesAbout({
					league_id:    +league_id,
					model:        new Backbone.Model(),
					league:       new Model.TippingLeague(),
					user:         this.user,
					joined_users: new Collection.TippingCoaches,
					rounds:       new Collection.Rounds()
				});

			leaguesAbout.on('rounds:fetched', function(rounds){
				leaguesManageControls.trigger('show:view:tips:btn', rounds);
			});

			leaguesAbout.on('leagues:view:menu', _.bind(this.leaguesViewMenu, this));
			leaguesAbout.on('leagues_leave:success', this.navigateToLeaguesList);
			leaguesAbout.on('leagues:http_status:404', this.navigateToLeaguesList);

			this.tippingLayout.tips.show(leaguesManage);

			leaguesManage.info.show(leaguesManageControls);
			leaguesManage.tabs.show(leaguesAbout);

			this._after(league_id);

			return this;
		},
		leaguesTipsList: function (league_id) {

			this.start(league_id);

			var leaguesManage         = new Layout.TippingLeaguesManage(),
				leaguesManageControls = new View.TippingLeaguesManageControls({
					league_id: league_id,
					model:     new Backbone.Model(),
					share:     this.share,
					leagues:   new Collection.TippingLeagues(),
					ladder:    new Model.Ladder(),
					user:      this.user,
					template:  JST.TippingLeaguesManageControlsTipsList,
					className: 'tips-list-manage-controls'

				}),
				leaguesViewTipsList   = new View.TippingViewTipsList({
					childView:  View.TippingViewTipsListItem,
					league_id:  league_id,
					model:      new Backbone.Model(),
					league:     new Model.TippingLeague(),
					collection: new Collection.TippingLeagues(),
					rounds:     new Collection.Rounds(),
					user:       this.user
				});

			leaguesViewTipsList.on('rounds:fetched', function(rounds){
				leaguesManageControls.trigger('set:rounds:control', rounds);
			});

			leaguesManageControls.on('change:rounds:control', function(rounds_id){
				leaguesViewTipsList.trigger('change:rounds:control', rounds_id);
			});

			this.tippingLayout.tips.show(leaguesManage);

			leaguesManage.info.show(leaguesManageControls);
			leaguesManage.tabs.show(leaguesViewTipsList);

		}
	});

}(window, APP, Backbone, Marionette, $, _));